/* =============================================================
   Fusion Essence — fe-cart-enhancements.js  (v3)
   Fix: stock badge removed from cart drawer (product_available
   in /cart.js reflects any variant OOS, not the one in cart,
   causing false Backordered labels on in-stock items).
   ============================================================= */
(function () {
  'use strict';

  var FREE_SHIP_CENTS = 10000;
  var CURRENCY = '$';

  function fmt(c) { return CURRENCY + (c / 100).toFixed(2); }
  function clamp(v, lo, hi) { return Math.min(Math.max(v, lo), hi); }
  function esc(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function updateProgressBars(totalCents) {
    var remaining = FREE_SHIP_CENTS - totalCents;
    var pct = clamp((totalCents / FREE_SHIP_CENTS) * 100, 0, 100);
    document.querySelectorAll('.fe-ship-progress').forEach(function (bar) {
      var fill = bar.querySelector('.fe-ship-progress__fill');
      var msg  = bar.querySelector('.fe-ship-progress__msg');
      if (!fill || !msg) return;
      fill.style.width = pct + '%';
      bar.setAttribute('aria-valuenow', Math.round(pct));
      if (remaining <= 0) {
        msg.innerHTML = '<strong>\u2713 You\u2019ve unlocked free shipping!</strong>';
        bar.classList.add('fe-ship-progress--unlocked');
      } else {
        msg.innerHTML = 'Add <strong>' + fmt(remaining) + '</strong> more for <strong>FREE shipping</strong>';
        bar.classList.remove('fe-ship-progress--unlocked');
      }
    });
    document.querySelectorAll('.fe-ship-bar-compact').forEach(function (bar) {
      var lbl  = bar.querySelector('.fe-ship-bar-compact__label');
      var fill = bar.querySelector('.fe-ship-bar-compact__fill');
      var unl  = bar.querySelector('.fe-ship-bar-compact__unlocked');
      if (remaining <= 0) {
        if (lbl)  lbl.style.display = 'none';
        if (fill && fill.parentNode) fill.parentNode.style.display = 'none';
        if (unl)  unl.style.display = 'inline';
      } else {
        if (lbl)  { lbl.textContent = fmt(remaining) + ' to free ship'; lbl.style.display = 'inline'; }
        if (fill) { fill.style.width = pct + '%'; }
        if (unl)  unl.style.display = 'none';
      }
    });
  }

  function injectProgressOnPDP() {
    if (document.querySelector('.fe-ship-progress--pdp')) return;
    var payBtns = document.querySelector('.payment-buttons');
    if (!payBtns) return;
    var wrap = document.createElement('div');
    wrap.className = 'fe-ship-progress fe-ship-progress--pdp';
    wrap.setAttribute('role','progressbar');
    wrap.setAttribute('aria-valuemin','0');
    wrap.setAttribute('aria-valuemax','100');
    wrap.setAttribute('aria-valuenow','0');
    wrap.innerHTML = '<div class="fe-ship-progress__track"><div class="fe-ship-progress__fill"></div></div><p class="fe-ship-progress__msg">Calculating\u2026</p>';
    payBtns.parentNode.insertBefore(wrap, payBtns);
  }

  function ensureProgressInDrawer() {
    var footer = document.getElementById('fe-cart-footer');
    if (!footer || footer.querySelector('.fe-ship-progress')) return;
    var wrap = document.createElement('div');
    wrap.className = 'fe-ship-progress';
    wrap.setAttribute('role','progressbar');
    wrap.setAttribute('aria-valuemin','0');
    wrap.setAttribute('aria-valuemax','100');
    wrap.setAttribute('aria-valuenow','0');
    wrap.innerHTML = '<div class="fe-ship-progress__track"><div class="fe-ship-progress__fill"></div></div><p class="fe-ship-progress__msg">Calculating\u2026</p>';
    footer.insertBefore(wrap, footer.firstChild);
  }

  function initBundlePricing() {
    var container = document.querySelector('[data-bundle-qty]');
    if (!container) return;
    var bundleQty   = parseInt(container.dataset.bundleQty, 10) || 2;
    var bundlePrice = parseInt(container.dataset.bundlePrice, 10) || 0;
    if (!bundlePrice) return;
    var qtyInput = document.querySelector('[name="quantity"]');
    if (!qtyInput) return;
    var msgEl = document.createElement('p');
    msgEl.className = 'fe-bundle-msg';
    qtyInput.parentNode.insertBefore(msgEl, qtyInput.nextSibling);
    function update() {
      var qty = parseInt(qtyInput.value, 10) || 1;
      if (qty >= bundleQty) {
        msgEl.textContent = qty + ' for ' + CURRENCY + (qty * bundlePrice / 100).toFixed(2) + ' \u2014 bundle price!';
        msgEl.style.color = '#2D6A4F';
      } else {
        msgEl.textContent = 'Add ' + (bundleQty - qty) + ' more for the bundle deal';
        msgEl.style.color = '#7B4F8E';
      }
    }
    qtyInput.addEventListener('change', update);
    qtyInput.addEventListener('input',  update);
    update();
  }

  function fetchCart(cb) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateProgressBars(cart.total_price);
        renderDrawerItems(cart);
        updateHeaderCount(cart.item_count);
        if (cb) cb(cart);
      })
      .catch(function (e) { console.warn('[FE cart]', e); });
  }

  function renderDrawerItems(cart) {
    var itemsEl  = document.getElementById('fe-cart-items');
    var countEl  = document.getElementById('fe-cart-count');
    var subEl    = document.getElementById('fe-cart-subtotal');
    var footerEl = document.getElementById('fe-cart-footer');
    var loadEl   = document.getElementById('fe-cart-loading');
    if (!itemsEl) return;
    if (loadEl)  loadEl.style.display   = 'none';
    itemsEl.style.display = 'block';
    var n = cart.item_count;
    if (countEl) countEl.textContent = n + (n === 1 ? ' item' : ' items');
    if (subEl)   subEl.textContent   = fmt(cart.total_price);
    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="fe-cart-empty"><span>&#x1F6D2;</span><p>Your cart is empty</p><a href="/collections/all" class="fe-cart-shop-link">Start shopping \u2192</a></div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }
    var html = '';
    cart.items.forEach(function (item) {
      var priceHtml = (item.compare_at_price && item.compare_at_price > item.final_price)
        ? '<span class="fe-cart-item__price fe-cart-item__price--sale">' + fmt(item.final_line_price) + '</span><s class="fe-cart-item__compare">' + fmt(item.compare_at_price * item.quantity) + '</s>'
        : '<span class="fe-cart-item__price">' + fmt(item.final_line_price) + '</span>';
      html += '<div class="fe-cart-item" data-key="' + esc(item.key) + '">' +
        '<a href="' + esc(item.url) + '"><img class="fe-cart-item__img" src="' + esc(item.image) + '" alt="' + esc(item.product_title) + '" loading="lazy"></a>' +
        '<div class="fe-cart-item__info">' +
          '<a class="fe-cart-item__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="fe-cart-item__variant">' + esc(item.variant_title) + '</div>' : '') +
          '<div class="fe-cart-item__row">' +
            priceHtml +
            '<div class="fe-cart-item__qty-ctrl">' +
              '<button class="fe-qty-btn" data-action="dec" data-key="' + esc(item.key) + '" aria-label="Decrease">&#x2212;</button>' +
              '<span class="fe-qty-val">' + item.quantity + '</span>' +
              '<button class="fe-qty-btn" data-action="inc" data-key="' + esc(item.key) + '" aria-label="Increase">&#x2B;</button>' +
            '</div>' +
          '</div>' +
          '<button class="fe-cart-item__remove" data-key="' + esc(item.key) + '" aria-label="Remove">Remove</button>' +
        '</div></div>';
    });
    itemsEl.innerHTML = html;
    if (footerEl) footerEl.style.display = 'block';
    if (footerEl && !footerEl.querySelector('.fe-est-shipping')) {
      var note = document.createElement('p');
      note.className = 'fe-est-shipping';
      note.textContent = 'Shipping & taxes calculated at checkout';
      var subRow = footerEl.querySelector('.fe-cart-drawer__subtotal');
      if (subRow) footerEl.insertBefore(note, subRow.nextSibling);
    }
    ensureProgressInDrawer();
    updateProgressBars(cart.total_price);
    attachQtyHandlers();
  }

  function attachQtyHandlers() {
    document.querySelectorAll('.fe-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.key;
        var qtyEl = btn.parentNode.querySelector('.fe-qty-val');
        var cur = parseInt(qtyEl ? qtyEl.textContent : 1, 10);
        changeItem(key, btn.dataset.action === 'inc' ? cur + 1 : Math.max(0, cur - 1));
      });
    });
    document.querySelectorAll('.fe-cart-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () { changeItem(btn.dataset.key, 0); });
    });
  }

  function changeItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawerItems(cart);
        updateProgressBars(cart.total_price);
        updateHeaderCount(cart.item_count);
      }).catch(function (e) { console.warn('[FE changeItem]', e); });
  }

  function updateHeaderCount(n) {
    document.querySelectorAll('.header-cart__count,[data-cart-count],.cart-item-count,.cart-count-bubble span')
      .forEach(function (el) { el.textContent = n; });
  }

  function openDrawer() {
    var drawer  = document.getElementById('fe-cart-drawer');
    var overlay = document.getElementById('fe-cart-overlay');
    if (!drawer) return;
    if (window.innerWidth < 600) {
      var sel = document.querySelector('.selector-wrapper, .product-form');
      if (sel) {
        var r = sel.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) {
          window.scrollTo({ top: window.scrollY + r.bottom + 20, behavior: 'smooth' });
        }
      }
    }
    drawer.classList.add('fe-cart-drawer--open');
    if (overlay) { overlay.classList.add('fe-cart-overlay--open'); overlay.setAttribute('aria-hidden','false'); }
    document.body.style.overflow = 'hidden';
  }

  function showDrawerLoading() {
    var l = document.getElementById('fe-cart-loading');
    var i = document.getElementById('fe-cart-items');
    var f = document.getElementById('fe-cart-footer');
    if (l) l.style.display = 'flex';
    if (i) i.style.display = 'none';
    if (f) f.style.display = 'none';
  }

  var _adding = false;
  function hardenATC() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action) return;
      if (form.action.indexOf('/cart/add') === -1 && !form.classList.contains('ajax-product-form')) return;
      var qtyInput = form.querySelector('[name="quantity"]');
      if (qtyInput && (!qtyInput.value || parseInt(qtyInput.value, 10) < 1)) qtyInput.value = 1;
      if (_adding) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      _adding = true;
      var btn    = form.querySelector('[type="submit"],[data-add-to-cart]');
      var textEl = btn ? (btn.querySelector('[data-add-to-cart-text]') || btn) : null;
      var orig   = textEl ? textEl.textContent.trim() : 'Add to cart';
      if (btn)    { btn.disabled = true; btn.setAttribute('aria-busy','true'); }
      if (textEl) { textEl.textContent = 'Adding\u2026'; }
      setTimeout(function () {
        _adding = false;
        if (btn)    { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        if (textEl) {
          textEl.textContent = '\u2713 Added!';
          setTimeout(function () { textEl.textContent = orig; }, 2200);
        }
      }, 1600);
    }, true);
  }

  function injectCardStockBadges() {
    document.querySelectorAll('.product-block').forEach(function (card) {
      if (card.querySelector('.fe-stock-badge-card')) return;
      var isSoldOut = card.classList.contains('product-block--sold-out') || !!card.querySelector('.product-label--sold-out');
      var isBackorder = card.classList.contains('product-block--backorder');
      if (!isSoldOut && !isBackorder) return;
      var badge = document.createElement('span');
      badge.className = 'fe-stock-badge-card ' + (isSoldOut ? 'fe-stock-badge-card--out' : 'fe-stock-badge-card--back');
      badge.textContent = isSoldOut ? 'Sold Out' : 'Backordered';
      var imgWrap = card.querySelector('.product-block__image-container,.grid__image-ratio');
      if (imgWrap) {
        var overlay = imgWrap.querySelector('.fe-badge-overlay') || document.createElement('div');
        overlay.className = 'fe-badge-overlay';
        overlay.appendChild(badge);
        imgWrap.appendChild(overlay);
      }
    });
  }

  function improveRelatedProducts() {
    var section = document.querySelector('.product-recommendations,[data-section-type="product-recommendations"]');
    if (!section) return;
    section.querySelectorAll('.product-block--sold-out').forEach(function (c) { c.style.display = 'none'; });
    section.querySelectorAll('.product-block img').forEach(function (img) {
      if (!img.alt) {
        var t = img.closest('.product-block') && img.closest('.product-block').querySelector('.product-block__title-link,.product-block__title');
        if (t) img.alt = t.textContent.trim();
      }
      img.addEventListener('error', function () {
        img.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="300" height="300"><rect fill="%23f5f0e8" width="300" height="300"/></svg>';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    hardenATC();
    initBundlePricing();
    injectProgressOnPDP();
    injectCardStockBadges();
    improveRelatedProducts();
    fetchCart();
    document.addEventListener('ajaxProduct:added', function () {
      showDrawerLoading(); openDrawer(); fetchCart();
    });
    document.addEventListener('click', function (e) {
      var cartLink = e.target.closest('a[href="/cart"],.utils__item--cart a,.header-cart a,.header-cart__count');
      if (cartLink && !e.target.closest('#fe-cart-drawer')) {
        e.preventDefault(); showDrawerLoading(); openDrawer(); fetchCart();
      }
    });
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          if (m.addedNodes.length) { injectCardStockBadges(); improveRelatedProducts(); }
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  });

})();
